import React from 'react';
import { useHistory } from 'react-router-dom';

import BasicButton from 'components/buttons/basicButton';
import styled from 'styled-components';

import aampeTheme from '../../../../../constants/aampeTheme';
import routes from '../../../../../constants/routes';

import useRoleFlags from 'hooks/auth/useRoleFlags';
import useGetLocationState from 'hooks/helper/useGetLocationState';

import { FormulaCoverageMap } from 'models/personalization.model';

import CoverageDrawerTable from './CoverageDrawerTable';

export type FormulaCoverageTableProps = {
    title: string;
    showAddMessageButton?: boolean;
    data: FormulaCoverageMap[];
    isLoading: boolean;
    tableName: string;
};

const FormulaCoverageTable: React.FC<FormulaCoverageTableProps> = ({
    title,
    showAddMessageButton,
    data,
    isLoading,
    tableName,
}) => {
    const history = useHistory();
    const { hasWriteAccess } = useRoleFlags();
    const { getLocationState } = useGetLocationState(
        'Back to Content coverage',
    );

    return (
        <Container>
            <ActionContainer>
                <Heading>{title}</Heading>
                {showAddMessageButton && hasWriteAccess && (
                    <BasicButton
                        isPrimary={false}
                        name={'+ New message'}
                        action={(e) => {
                            e.stopPropagation();
                            history.push(
                                routes.formulasCreate,
                                getLocationState(),
                            );
                        }}
                    />
                )}
            </ActionContainer>

            <CoverageDrawerTable
                data={data}
                isLoading={isLoading}
                tableName={tableName}
                hasWriteAccess={hasWriteAccess}
            />
        </Container>
    );
};

export default FormulaCoverageTable;

const Container = styled.div({
    display: 'flex',
    padding: aampeTheme.spacing4(5),
    paddingBottom: 0,
    gap: aampeTheme.spacing4(4),
    flexDirection: 'column',
});

const Heading = styled.span({
    color: aampeTheme.colors.neutral09,
    fontSize: aampeTheme.size.font.title,
    fontWeight: aampeTheme.weights.medium,
});

const ActionContainer = styled.div({
    display: 'flex',
    justifyContent: 'space-between',
});
